// extracted by mini-css-extract-plugin
export default {"formContainer":"ForecastedConsumption_formContainer__EYqd-","selectContainer":"ForecastedConsumption_selectContainer__uLUu6"};